import styled from 'styled-components';

export const Layout = styled.div`
  display: flex;
  justify-content: center;
  padding: 2rem;
  font-size: 2rem;
`;
